import React from "react";
import Input from "../../../../../components/FormComponents/Input";
import { getLabelForKey } from "../../../../../utils/Config/DefaultConfig/formFieldConfig";

const EditRecordsetList = (props) => {
  const { editFieldData, setEditFieldData } = props;

  const handleChangeInput = (name, value) => {
    setEditFieldData({ ...editFieldData, [name]: value });
  };
  return (
    <>
      <Input
        label={getLabelForKey("label")}
        value={editFieldData.label}
        name="label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <Input
        label={getLabelForKey("form_display_label")}
        value={editFieldData.form_display_label}
        name="form_display_label"
        onChange={({ target }) => handleChangeInput(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          label={getLabelForKey("disable")}
          checked={editFieldData.disable}
          name="disable"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
        <Input
          type="checkbox"
          label={getLabelForKey("is_card_format")}
          checked={editFieldData.is_card_format}
          name="is_card_format"
          onChange={({ target }) => handleChangeInput(target.name, target.checked)}
          containerClassName="w_50"
        />
      </div>
      <div className="field_horizontal_container">
        <Input
          label={getLabelForKey("help_text")}
          value={editFieldData.help_text}
          name="help_text"
          onChange={({ target }) => handleChangeInput(target.name, target.value)}
        />
      </div>
    </>
  );
};

export default EditRecordsetList;
